import { useState, useEffect } from 'react';
import { supabaseGetter } from '~/api/supabase-getter';

/**
 * Hook to fetch crop growth types
 * @returns {Object} Crop growth types, loading state, and error
 */
export const useCropGrowthTypes = () => {
  const [cropGrowthTypes, setCropGrowthTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);

      try {
        const { data: cropGrowthTypesData, error: cropGrowthTypesError } =
          await supabaseGetter.cropGrowthTypes.getAll();

        if (cropGrowthTypesError) throw cropGrowthTypesError;

        setCropGrowthTypes(cropGrowthTypesData || null);
      } catch (err) {
        console.error('Error fetching crop growth types data:', err);
        setError(err.message);
        setCropGrowthTypes([]);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  return {
    cropGrowthTypes,
    loading,
    error,
    invalidate: () => {
      supabaseGetter.cropGrowthTypes.invalidate();
    }
  };
}
